import { createRoot } from 'react-dom/client';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// apex-chart
import 'assets/third-party/react-table.css';

// PrivacyPal brand fonts (Inter / Radley / JetBrains Mono) are loaded via Google Fonts in index.html

// project imports
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import { PartnerAuthProvider } from 'contexts/PartnerAuthContext';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <ConfigProvider>
    <PartnerAuthProvider>
      <App />
    </PartnerAuthProvider>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
